import React from "react";
import { ActionButton } from "./ResultsPrimitives.jsx";

function resolveErrorMessage(error) {
  if (error instanceof Error && typeof error.message === "string" && error.message.trim()) {
    return error.message;
  }

  return "Une erreur inattendue a interrompu l'affichage de l'application.";
}

function ErrorFallback({ error }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-5 py-8 max-[720px]:px-4">
      <section className="w-full max-w-3xl overflow-hidden rounded-2xl border border-border-danger-muted bg-surface shadow-card">
        <div className="border-b border-line-soft bg-danger-soft px-6 py-5 max-[720px]:px-5">
          <p className="text-[0.68rem] font-black uppercase tracking-[0.2em] text-danger">
            Incident d&apos;affichage
          </p>
          <h1 className="mt-2 text-[clamp(1.6rem,2.4vw,2.2rem)] font-semibold tracking-[-0.04em] text-text">
            L&apos;application a rencontré une erreur.
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-muted-strong">
            Le shell a été protégé pour éviter un écran vide permanent. Rechargez l&apos;interface pour repartir sur un état sain.
          </p>
        </div>

        <div className="grid gap-5 px-6 py-6 max-[720px]:px-5">
          <div className="rounded-[22px] border border-line-soft bg-surface-muted px-4 py-4">
            <p className="text-[0.68rem] font-black uppercase tracking-[0.18em] text-muted-strong">
              Détail capturé
            </p>
            <p className="mt-3 wrap-break-word text-sm leading-6 text-muted-strong">
              {resolveErrorMessage(error)}
            </p>
          </div>

          <div className="flex flex-wrap gap-3">
            <ActionButton
              tone="optimize"
              size="md"
              onClick={() => window.location.reload()}
              className="px-4!"
            >
              Recharger l&apos;application
            </ActionButton>
            <a
              href="/"
              className="inline-flex items-center justify-center rounded-full border border-line-soft bg-white px-4 py-2.5 text-sm font-semibold text-muted-strong transition hover:border-accent hover:text-accent"
            >
              Retour à l&apos;accueil
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default class ApplicationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return <ErrorFallback error={this.state.error} />;
    }

    return this.props.children;
  }
}